import Axios from "axios";

import api from "./api";

import { subDays, format } from 'date-fns';

const PATHS = {
  loginPath: "",
  userInfoPath: "residential/store/v1/stores/me",
  economicGroupPath: "residential/store/v1/stores/me/economic-groups",
  orderGaPath: "/residential/order/v1/orders-ga?store-id=",
  getPublicPath: "/residential/ultratop/v1/publicos",
};

export const logIn = (body, parameters) => {
  return api.post(PATHS.loginPath, body, parameters);
};

export const userInfo = (parameters) => {
  return api.get(PATHS.userInfoPath, parameters);
};

export const economicGroup = (parameters) => {
  return api.get(PATHS.economicGroupPath, parameters);
};

export const orderGa = (storeId, parameters) => {
  const currentDate = new Date();
  const startDate = subDays(currentDate, 60);
  const formattedStartDate = format(startDate, 'yyyy-MM-dd');
  return api.get(`${PATHS.orderGaPath}${storeId}&start-date=${formattedStartDate}`, parameters);
};

export const getPublic = (parameters) => {
  return api.get(PATHS.getPublicPath, parameters);
};

export const changeName = (url, body, parameters) => {
  return api.patch(url, body, parameters);
}
